import React from 'react';

import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';

import { blackberry, grape, greyStroke, white } from 'lib/css/colors';

// A hard binary switch (no "show all" state), mirroring the V2 review view's Toggle.
function Toggle({ checked, onToggle, label }) {
  return (
    <div
      role="switch"
      aria-checked={checked}
      tabIndex={0}
      onClick={onToggle}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onToggle();
        }
      }}
      className={css(styles.toggleWrapper)}
    >
      <div className={css(styles.toggleTrack, checked && styles.toggleTrackOn)}>
        <div className={css(styles.toggleThumb, checked && styles.toggleThumbOn)} />
      </div>
      <span className={css(styles.toggleText)}>{label}</span>
    </div>
  );
}

Toggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};

const styles = StyleSheet.create({
  toggleWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    cursor: 'pointer',
    userSelect: 'none',
    whiteSpace: 'nowrap',
  },
  toggleTrack: {
    position: 'relative',
    width: 36,
    height: 20,
    borderRadius: 10,
    backgroundColor: greyStroke,
    flexShrink: 0,
  },
  toggleTrackOn: { backgroundColor: grape },
  toggleThumb: {
    position: 'absolute',
    top: 2,
    left: 2,
    width: 16,
    height: 16,
    borderRadius: '50%',
    backgroundColor: white,
  },
  toggleThumbOn: { left: 18 },
  toggleText: { fontSize: 13, fontWeight: 500, color: blackberry },
});

export default Toggle;
